import React, { Component } from 'react';

class DenunciaTarjeta extends Component {
    render() { 

        const {data,actions,tarjetaDenuncia} = this.props;

        let tituloModal = "Denuncia"
        let mensajeSuperior = "";
        let mensajeInferior = "";
        let pendienteHab = false;
        
        if(tarjetaDenuncia){
            mensajeSuperior = "¿Confirma la DENUNCIA de la tarjeta " + tarjetaDenuncia.NumeroTarjeta + " del cliente " + tarjetaDenuncia.NombreCliente + "?";
            mensajeInferior = "Si confirma la operación se realizará la baja inmediata de la tarjeta indicada";
            pendienteHab = data.IntegrantesCuenta.integrantes.some(t=>t.ClienteId == tarjetaDenuncia.ClienteId && 
                t.TarjetaCreditoEstadoId == 3 && 
                !t.FechaHabilitacion &&
                t.FVencimiento < new Date());
        }

        return (  
        <div className='modalIntegrantesInterior'>
            <div>
                {tituloModal}
            </div>
            <div className='modaDenunciaTarjetaCuerpo'>
                <div>{mensajeSuperior}</div>
                <div>{mensajeInferior}</div>
                <div>
                    <div className="default-checkbox checkProcesosSmall">
                        <input
                            id={"SolicitarReimpresionDenuncia"}
                            type="checkbox"
                            name={"SolicitarReimpresionDenuncia"}
                            checked={data.IntegrantesCuenta.solicitaReimpresion}
                            disabled={false}
                            onChange={(e) => actions.checkReimpresion()}
                        />
                    </div>
                    <label className="label-primary" htmlFor={"SolicitarReimpresionDenuncia"}>Requerir reimpresión de tarjeta</label>
                </div>
                {false && <div className='advertencia-modal-integrante'>El cliente tiene una tarjeta en distribución, consulte... <span className='icono-delivery'></span></div>}
                {pendienteHab && <div className='advertencia-modal-integrante'>El cliente tiene una tarjeta pendiente de habilitación</div>}
            </div>
            <div className='modaConfirmadorBloqueoInteriorFooter'>
                <button onClick={()=>actions.modalSeccion("IntegrantesCuenta","DENUNCIA-TARJETA",false,null,"tarjetaDenuncia")} className='btn btn-secondary'>Cancelar</button>
                <button onClick={()=>null} className='btn btn-cta'>Aceptar</button>
            </div>
        </div>
       );
    }   
}
export default DenunciaTarjeta;